import PropTypes from 'prop-types';

import { Checkbox } from '#/modules/commonComponents/checkbox';

/** 單一物料的 SN 候選勾選（上限 = requiredQty）。 */
const SalesOrderSnCandidateChecklist = ({ mtr, selectedIds, onToggle, disabled = false }) => {
  const candidates = mtr?.candidates ?? [];
  const isFull = selectedIds.length >= Number(mtr?.requiredQty ?? 0);

  if (candidates.length === 0) {
    return <p className="py-4 text-sm text-muted-foreground">尚無可選序號</p>;
  }

  return (
    <ul className="divide-y divide-slate-200 rounded-md border border-slate-200 bg-panel">
      {candidates.map((candidate) => {
        const snId = String(candidate.mtrSnId);
        const checked = selectedIds.includes(snId);
        const inputId = `sn-${mtr.salesOrderLineMtrId}-${snId}`;
        return (
          <li key={snId} className="flex items-center gap-3 px-3 py-2">
            <Checkbox
              id={inputId}
              checked={checked}
              disabled={disabled || (!checked && isFull)}
              onCheckedChange={(next) => onToggle(snId, Boolean(next))}
            />
            <label htmlFor={inputId} className="flex-1 font-mono text-sm">
              {candidate.serialNumber}
            </label>
            <span className="text-xs text-muted-foreground">
              {candidate.inspectionStatus}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

SalesOrderSnCandidateChecklist.propTypes = {
  mtr: PropTypes.object.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default SalesOrderSnCandidateChecklist;
